import { Form, SelectProps } from "antd";
import { useEffect, useState } from "react";

import { _isRequired, parseErrorMessage, renderBankListOptions } from "utils";
import { BankGridDto } from "interfaces";
import { getBankList } from "services";
import { SearchSelect } from "ui";

interface IProps {
  inputProps: SelectProps;
  onBankDataReceived: (bankData: BankGridDto) => void;
  name: string | string[];
}

export const BankSelect = (props: IProps) => {
  const form = Form.useFormInstance();

  const [banks, setBanks] = useState<BankGridDto[]>([]);

  const [loading, setLoading] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const bikValue: string = Form.useWatch(props.name, form);
  const initialBikValue = props.inputProps.defaultValue as string;

  useEffect(() => {
    const fetchBanks = async () => {
      if (banks.length === 0) {
        setLoading(true);
        try {
          const response = await getBankList({ size: 10000 });
          setBanks(response.content ?? []);
          setInitialized(true);
        } catch (e: any) {
          console.error(parseErrorMessage(e));
        } finally {
          setLoading(false);
        }
      }
    };

    fetchBanks();
  }, [banks.length]);

  useEffect(() => {
    if (initialized && banks.length > 0) {
      if (bikValue) {
        const bankFromForm = banks.find((bank) => bank.bik === bikValue);
        if (bankFromForm) {
          props.onBankDataReceived(bankFromForm);
          return;
        }
      }

      if (initialBikValue && initialBikValue !== bikValue) {
        const initialBank = banks.find((bank) => bank.bik === initialBikValue);
        if (initialBank) {
          form.setFieldValue(props.name, initialBikValue);
          props.onBankDataReceived(initialBank);
        }
      }
    }
  }, [initialized, banks.length, bikValue, initialBikValue, props.onBankDataReceived, props.name, form, banks, props]);

  const handleChange = (value: string) => {
    const currentBank = banks.find((item) => item.bik === value);
    if (currentBank) {
      props.onBankDataReceived(currentBank);
    }
  };

  return (
    <Form.Item name={props.name} rules={[_isRequired("Банк обязателен для ввода")]} className="full-width">
      <SearchSelect
        {...props.inputProps}
        value={bikValue}
        placeholder="Банк"
        disabled={props.inputProps.disabled || loading}
        onChange={handleChange}
        loading={loading}
      >
        {renderBankListOptions(banks)}
      </SearchSelect>
    </Form.Item>
  );
};
